<template>
  <!-- 域名管理 -->
  <div class="container">
    <div>
      <Form
        @submit.native.prevent
        :model="formData"
        label-position="left"
        class="mytable-titleBox clearfix"
      >
        <RadioGroup
          v-model.trim="formData.status"
          type="button"
          class="fl mr20"
          @on-change="handleRefundchange"
        >
          <Radio :label="-1">全部</Radio>
          <Radio :label="0">未使用</Radio>
          <Radio :label="1">在使用</Radio>
          <Radio :label="2">已封</Radio>
        </RadioGroup>
        <div class="fr addAuthor">
          <Button type="primary" @click="add" class="ml32">新增</Button>
        </div>
      </Form>
    </div>
    <Table
      :loading="tableLoading"
      class="mt24"
      :columns="columns"
      :data="tableData"
    ></Table>
    <Modal
      v-model="modalVisibile"
      width="724"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        :rules="modalRule"
        label-position="top"
      >
        <div class="clearfix mb32">
          <FormItem label="ID" class="fl" prop="username">
            <Input
              v-model="modalForm.id"
              :maxlength="6"
              class="input294Width"
            ></Input>
          </FormItem>
          <FormItem label="域名" class="fl ml72" prop="login_name">
            <Input v-model="modalForm.domain" class="input294Width"></Input>
          </FormItem>
          <FormItem label="高防" class="fl mt24" prop="password">
            <Select v-model.trim="modalForm.ddos" class="input294Width">
              <Option value="0">否</Option>
              <Option value="1">是</Option>
            </Select>
          </FormItem>
          <FormItem label="作者" class="fl mt24 ml72" prop="password">
            <Select
              ref="select"
              v-model="authorJson"
              style="margin-top: 7px"
              class="input294Width"
            >
              <Option
                v-for="(option, index) in authorData"
                :value="JSON.stringify(option)"
                :key="index"
                >{{ option.author }}</Option
              >
            </Select>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button
          :loading="modalLoading"
          type="primary"
          @click="handleModalSubmit"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    /> -->
  </div>
</template>

<script>
import { getCookie } from "../../libs/util";
import mixins from "@/mixins/page";
import * as qiniu from "qiniu-js";
import authorOrder from "@/components/authorOrder";
import { setInterval } from "timers";
export default {
  mixins: [mixins],
  name: "authorManage",
  components: {
    authorOrder,
  },
  data() {
    return {
      authorJson: "",
      authorData: [],
      modalRule: {
        // username: [
        //   { required: true, message: "请输入作者名称", trigger: "blur" },
        // ],
        // login_name: [
        //   { required: true, message: "请输入登录账号", trigger: "blur" },
        // ],
        // password: [{ required: true, message: "请输入秘密", trigger: "blur" }],
        // confirmPwd: [
        //   { required: true, message: "请输入确认密码", trigger: "blur" },
        //   { validator: validateConfirmPass, trigger: "blur" },
        // ],
        // summary: [
        //   { required: true, message: "请输入作者简介", trigger: "blur" },
        // ],
        // sort: [{ required: true, message: "请输入排序号", trigger: "blur" }],
        // basket: [
        //   { required: true, message: "请输入投几中几", trigger: "blur" },
        //   { validator: validateBasket, trigger: "blur" },
        // ],
      },
      modalVisibile: false,
      modalTitle: "新增域名",
      modalForm: {},
      page_num: 1,
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },

      formData: {
        status: -1,
      },
      formData1: {
        status: -1,
      },
      tableLoading: false,
      tableData: [],
      modalLoading: false,
      columns: [
        {
          title: "ID",
          key: "id",
          width: 180,
          align: "center",
        },
        {
          title: "域名",
          key: "domain",
          align: "center",
        },
        {
          title: "作者",
          key: "author",
          align: "center",
        },
        {
          title: "状态",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    blue: params.row.status == 1 ? true : false,
                    red: params.row.status == 2 ? true : false,
                  },
                },
                params.row.status
                  ? params.row.status == 1
                    ? "在使用"
                    : "已封"
                  : "未使用"
              ),
            ]);
          },
        },
        {
          title: "高防",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    red: params.row.ddos ? false : true,
                  },
                },
                params.row.ddos ? "是" : "否"
              ),
            ]);
          },
        },
        {
          title: "修改时间",
          key: "modifyTime",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 170,
          render: (h, params) => {
            // var status = 0;
            //未使用
            return h("div", [
              params.row.status == 0 &&
                params.row.authorId == 1 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleEdit(1, 1, params.row), //使用传1，封传2，飞刀1，其它2 ,虎扑 3
                    },
                  },
                  "飞刀使用"
                ),
              params.row.status == 0 &&
                params.row.authorId == 2 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleEdit(1, 2, params.row),
                    },
                  },
                  "其它使用"
                ),
              params.row.status == 0 &&
                params.row.authorId == 3 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleEdit(1, 3, params.row),
                    },
                  },
                  "虎扑使用"
                ),
              params.row.status == 1 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleEdit(2, null, params.row),
                    },
                  },
                  "作废"
                ),
              params.row.status > 1 &&
                h(
                  "span",
                  {
                    class: {
                      btn_edit: true,
                    },
                    on: {
                      click: () => this.handleDel(params.row),
                    },
                  },
                  "删除"
                ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getAuthorList();
    this.getTableData();
  },
  methods: {
    handleDel(params) {
      this.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true,
                },
              },
              "删除"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              "要删除此域名吗？"
            ),
          ]);
        },
        onOk: () => {
          this.$api.domianDel({ domain: params.domain }).then((res) => {
            if (res.code == 0) {
              this.$Message.success("删除成功");
              this.getTableData();
            } else {
              this.$Message.error({
                content: res.msg,
                duration: 10,
              });
            }
          });
        },
      });
    },
    getAuthorList() {
      this.$api.domainAuthorList({}).then((res) => {
        if (res.code == 0) {
          this.authorData = res.data;
        }
      });
    },
    add() {
      this.modalVisibile = true;
    },
    handleModalSubmit() {
      if (
        !this.authorJson ||
        !this.modalForm.id ||
        !this.modalForm.domain ||
        !this.modalForm.ddos
      ) {
        this.$Message.warning("请填写完整信息！");
        return;
      }
      this.modalForm.author_id = JSON.parse(this.authorJson).id;
      this.modalForm.app_id = JSON.parse(this.authorJson).app_id;
      this.modalForm.app_secret = JSON.parse(this.authorJson).app_secret;
      this.modalForm.author = JSON.parse(this.authorJson).author;

      this.modalForm.ddos = Number(this.modalForm.ddos);
      this.modalForm.id = Number(this.modalForm.id);

      this.modalLoading = true;
      this.$api
        .domianAdd({ ...this.modalForm })
        .then((res) => {
          if (res.code == 0) {
            this.$Message.success("添加成功");
            this.modalLoading = false;
            this.handleCancel();
            this.getTableData();
          } else {
            this.$Message.error({
              content: res.msg,
              duration: 10,
            });
            this.modalLoading = false;
          }
        })
        .catch((_) => {
          this.modalLoading = false;
        });
    },
    handleEdit(status, author, params) {
      //status 1使用  2作废
      var title = "";
      var cont = "";
      if (status == 2) {
        title = "作废域名";
        cont = "您确定要将该域名(" + params.domain + ")作废吗?";
      } else {
        title = "使用域名";
        cont = "您确定要使用该域名(" + params.domain + ")吗?";
      }
      this.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true,
                },
              },
              title
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              cont
            ),
          ]);
        },
        onOk: () => {
          this.$api
            .domianUse({ id: params.id, status: status, author: author })
            .then((res) => {
              if (res.code == 0) {
                this.$Message.success("操作成功");
                this.getTableData();
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 10,
                });
              }
            });
        },
      });
    },

    handleDateChange(val) {
      if (val[0]) {
        this.modalForm.start_time = val[0];
        this.modalForm.end_time = val[1];
      } else {
        this.modalForm.start_time = "";
        this.modalForm.end_time = "";
      }
    },
    handleRefundchange() {
      this.page_num = 1;
      this.getTableData();
    },

    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      let param = {
        status: this.formData.status,
        // page_num: this.page_num,
        // page_size: this.page_size,
      };
      this.$api.domianList(param).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;

          // this.total = res.data;
          this.tableLoading = false;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    // 弹框取消
    handleCancel() {
      this.$refs.modalForm.resetFields();
      this.modalForm = Object.assign({}, this.modalForm1);
      this.modalVisibile = false;
      this.authorJson = "";
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .ivu-form-item {
  margin-bottom: 0;
}

.checkReset:first-child {
  margin-right: 8px;
}

.ivu-modal-footer {
  border-top: none !important;
}

.shadowLine {
  width: 660px;
  height: 1px;
  background: #e9e9e9;
  margin: 24px 0;
}

.wechartBox {
  width: 282px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  line-height: 32px;
  padding-left: 12px;

  span {
    width: 74px;
    text-align: center;
    border-left: 1px solid #dce1e6;
    cursor: pointer;
  }
}

/deep/ .ivu-upload-drag {
  border: none;
  background: transparent;
}

/deep/ .textarea.ivu-input {
  min-height: 88px;
  height: 88px;
}

.playFont {
  color: #8a9299;
}

.boldTitle {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.graybg {
  width: 724px;
  height: 12px;
  background: #f0f3f5;
  position: relative;
  left: -32px;
  margin-bottom: 24px;
  margin-top: 8px;
}

.shadowTitleClick span {
  cursor: pointer;
}

/deep/ .table_pic {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
</style>
